(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57889],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 36837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_SectionTitle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./UI/components/SectionTitle/styles.module.scss
var styles_module = __webpack_require__(89494);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SectionTitle/utils/get-segment-text.js

var getSegmentText = function(text) {
    var parts = text.split(/(~~.*?~~)/g);
    return parts.map(function(part) {
        var isAlpa = /^~~.*~~$/.test(part);
        if (isAlpa) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "data-title-alpha": true,
                style: {
                    display: "inline"
                },
                children: part.slice(2, -2)
            }, part);
        }
        return part;
    });
};

;// CONCATENATED MODULE: ./UI/components/SectionTitle/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SectionTitle = function(param) {
    var type = param.type, titleStyle = param.titleStyle, title = param.title, titleVariant = param.titleVariant, secondTitle = param.secondTitle, secondTitleVariant = param.secondTitleVariant, subtitle = param.subtitle, secondSubtitle = param.secondSubtitle, description = param.description, secondDescription = param.secondDescription, className = param.className, children = param.children;
    var titleSegments = title === null || title === void 0 ? void 0 : title.split("||");
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).sectionTitleContainer, (styles_module_default())[type], className, titleStyle),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-title": true,
                    isBold: true,
                    size: useTypography/* TYPOGRAPHY_SIZE.headline38 */.y3.headline38,
                    mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                    variant: titleVariant,
                    className: (styles_module_default()).title,
                    children: titleSegments.length === 1 ? getSegmentText(title) : titleSegments.map(function(segment) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            ket: segment,
                            "data-title": true,
                            isBold: true,
                            size: useTypography/* TYPOGRAPHY_SIZE.headline38 */.y3.headline38,
                            mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                            variant: "span",
                            className: (styles_module_default()).title,
                            children: getSegmentText(segment)
                        });
                    })
                })
            })),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-subtitle": true,
                    size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                    className: (styles_module_default()).subtitle,
                    children: subtitle
                })
            })),
            descriptionParagraphs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 100,
                children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        "data-description": true,
                        size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                        className: (styles_module_default()).description,
                        children: text
                    }, "paragraph/".concat(index));
                })
            })),
            secondTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 150,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    isBold: true,
                    "data-second-title": true,
                    size: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                    variant: secondTitleVariant,
                    className: (styles_module_default()).title,
                    children: secondTitle
                })
            })),
            secondSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-second-subtitle": true,
                    className: (styles_module_default()).subtitle,
                    children: secondSubtitle
                })
            })),
            secondDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-second-description": true,
                    className: (styles_module_default()).description,
                    children: secondDescription
                })
            })),
            children
        ]
    });
};
SectionTitle.defaultProps = {
    type: "default",
    titleStyle: "",
    subtitle: "",
    description: null,
    className: null,
    title: null,
    secondTitle: "",
    secondSubtitle: "",
    secondDescription: "",
    titleVariant: "h2",
    secondTitleVariant: "h3"
};
SectionTitle.propTypes = {
    type: (prop_types_default()).string,
    titleStyle: (prop_types_default()).string,
    title: (prop_types_default()).string,
    secondTitle: (prop_types_default()).string,
    subtitle: (prop_types_default()).string,
    secondSubtitle: (prop_types_default()).string,
    description: (prop_types_default()).string,
    secondDescription: (prop_types_default()).string,
    className: (prop_types_default()).string,
    titleVariant: (prop_types_default()).string,
    secondTitleVariant: (prop_types_default()).string
};
/* harmony default export */ var components_SectionTitle = (SectionTitle);


/***/ }),

/***/ 78677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Wireframes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var data = __webpack_require__(27515);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/herlpers.js
var DEFAULT_MOBILE_IMAGE_SIZE = 350;
var DEFAULT_IMAGE_SIZE = 500;
var IMAGE_SIZES = {
    "marketplace-for-clairvoyant-services": 541,
    fernwayer: {
        default: 478,
        secondSectionView: 650
    },
    fireaway: {
        default: 425
    },
    dindon: {
        default: 440
    },
    "seven-pm-thursday": {
        default: 478
    },
    stickerbox: {
        default: 480
    },
    fairy: {
        default: 478
    },
    "open-sense": {
        default: 440
    },
    "drive-focus": {
        default: 440
    },
    tell: {
        default: 478
    },
    "travel-trivia": {
        default: 478
    },
    "cash-chat": {
        default: 478
    },
    beautonomy: 600,
    meateater: {
        default: 470
    },
    "separate-us": {
        default: 440
    },
    "fintech-app-for-credit-score": {
        default: 480
    },
    ubichat: {
        default: 500
    },
    telemojo: {
        default: 440
    },
    famlicious: 478,
    bionorica: {
        default: 500
    },
    humankind: {
        default: 515
    },
    blackbird: {
        default: 480
    },
    "software-for-mri-interpretation": 630,
    "fusion-markets": {
        default: 440
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 480
    },
    "mobile-bank-application": {
        default: 586
    },
    "forex-trading-platform": {
        default: 560
    },
    "kitchen-equipment-customizer": {
        default: 622
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 100
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 600
    },
    "ai-software-development-services": {
        firstSectionView: 208
    },
    "ai-documentation-processing": {
        firstSectionView: 522
    }
};
var MOBILE_IMAGE_SIZES = {
    fireaway: {
        default: 250
    },
    tell: {
        default: 350
    },
    "separate-us": {
        default: 180
    },
    "drive-focus": {
        default: 220
    },
    ubichat: {
        default: 220
    },
    "marketplace-for-clairvoyant-services": {
        default: 206
    },
    "fusion-markets": {
        default: 206
    },
    telemojo: {
        default: 206
    },
    blackbird: {
        default: 350
    },
    dindon: {
        default: 181
    },
    humankind: {
        default: 181
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 240
    },
    "mobile-bank-application": {
        default: 550
    },
    "forex-trading-platform": {
        default: 228
    },
    meateater: {
        default: 211
    },
    "kitchen-equipment-customizer": {
        default: 206
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 40
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 320
    },
    "ai-software-development-services": {
        firstSectionView: 188
    },
    "ai-documentation-processing": {
        firstSectionView: 206
    }
};

;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/useWireframes.js






var useWireframes = function(param) {
    var images = param.images, type = param.type, view = param.view;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var wireframeImages = images === null || images === void 0 ? void 0 : images.map(function(image) {
        var ref, ref1;
        var imageData = (0,helper/* getImage */.gJ)(image);
        var height = isMobileResolution ? ((ref = MOBILE_IMAGE_SIZES[type]) === null || ref === void 0 ? void 0 : ref[view || "default"]) || DEFAULT_MOBILE_IMAGE_SIZE : ((ref1 = IMAGE_SIZES[type]) === null || ref1 === void 0 ? void 0 : ref1[view || "default"]) || DEFAULT_IMAGE_SIZE;
        var scale = height / imageData.height;
        var width = Math.trunc(imageData.width * scale);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            width: width,
            height: height
        });
    });
    return {
        type: type,
        images: images,
        wireframeImages: wireframeImages,
        isMobileResolution: isMobileResolution
    };
};

// EXTERNAL MODULE: ./UI/components/Wireframes/styles.module.scss
var styles_module = __webpack_require__(5665);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Wireframes/index.jsx










var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Wireframe = function(props) {
    var ref = useWireframes(props), type = ref.type, wireframeImages = ref.wireframeImages;
    if (!wireframeImages) {
        return null;
    }
    return wireframeImages === null || wireframeImages === void 0 ? void 0 : wireframeImages.map(function(param) {
        var url = param.url, alt = param.alt, height = param.height, width = param.width;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            delay: 100
        }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((styles_module_default())[type], (styles_module_default()).container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    })
                ]
            })
        }), url);
    });
};
Wireframe.propTypes = {
    images: prop_types_default().arrayOf(prop_types_default().instanceOf(Object)).isRequired,
    type: (prop_types_default()).string.isRequired,
    view: (prop_types_default()).string
};
/* harmony default export */ var Wireframes = (Wireframe);


/***/ }),

/***/ 27515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ANIMATION_CASE_STUDY_PROPS; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);

var ANIMATION_CASE_STUDY_PROPS = {
    type: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ANIMATED_TYPE.isFade */ .BK.isFade,
    duration: 1000
};


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 89494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleContainer":"styles_sectionTitleContainer__YEeiB","title":"styles_title__m075V","subtitle":"styles_subtitle__2fL8O","description":"styles_description__WuHDh","default":"styles_default__R0jjX","side":"styles_side___qNH3"};

/***/ }),

/***/ 5665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZQHkg","animatedContainer":"styles_animatedContainer__WYfJB","image-scroll":"styles_image-scroll__pUNL8","stickerbox":"styles_stickerbox__y5DTR","image":"styles_image__bGCuA","fireaway":"styles_fireaway__l2P6I","seven-pm-thursday":"styles_seven-pm-thursday___Cl7g","open-sense":"styles_open-sense__Yklmv","drive-focus":"styles_drive-focus__12y7P","separate-us":"styles_separate-us__TLw4a","ubichat":"styles_ubichat__jbYPB","bionorica":"styles_bionorica__SM7Vw","fusion-markets":"styles_fusion-markets__H5xo9","beautonomy":"styles_beautonomy__ymseQ","meateater":"styles_meateater__qWYXE","mobile-music-app":"styles_mobile-music-app__hRFB5","blinking":"styles_blinking__7Ds4t","swing":"styles_swing__rXIHm","animateborder":"styles_animateborder__DhniH","animateborder-overlay":"styles_animateborder-overlay__8FnUW","animatecircle":"styles_animatecircle__kwr9O","animatedot":"styles_animatedot__9xDD6","animStar":"styles_animStar__EbuN6","hideText":"styles_hideText__hmhu8","spin":"styles_spin__8Cp8N","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__vtAMq","outOfTransparencyMobile":"styles_outOfTransparencyMobile__lpcr9","appearance":"styles_appearance__bMdbB","appearanceFromBelow":"styles_appearanceFromBelow__FL2aE","flicker":"styles_flicker__IS6Zf","vibrate1":"styles_vibrate1__jFR_O","rocket":"styles_rocket__zssUG","burgerItem1":"styles_burgerItem1__fTxlS","burgerItem2":"styles_burgerItem2__O_WVU","burgerItem3":"styles_burgerItem3__nrRQL","burgerItem1Reverse":"styles_burgerItem1Reverse__UKx57","burgerItem2Reverse":"styles_burgerItem2Reverse__IOcVP","burgerItem3Reverse":"styles_burgerItem3Reverse__O0X_q","arrow-down":"styles_arrow-down__7dLP_","image-scroll-reverse":"styles_image-scroll-reverse__Lo_CU","stickerbox-pointer-move":"styles_stickerbox-pointer-move__Un_to","hide-image":"styles_hide-image__bPthP","stickerbox-pointer-second":"styles_stickerbox-pointer-second__Yn3ZV","stickerbox-pointer-third":"styles_stickerbox-pointer-third__OBnx_","cedar-bounce":"styles_cedar-bounce__so6an"};

/***/ })

}]);